export default __webpack_public_path__ + "static/media/gradient-underlay.d425dcba.png";